// 登录模块

function userLogin(username, password) {
  return new Promise(resolve => {
    $.ajax({
      type: "post",
      url: APILogin,
      data: {
        action: "login",
        type: "b",
        username,
        password
      },
      dataType: "json",
      success: res => {
        if (res) {
          try {
            const jsonRes = JSON.parse(res);
            jsonRes.status == "ok" ? resolve(jsonRes.msg) : resolve(false);
          } catch (e) {
            console.log("登录出错");
            resolve(false);
          }
        } else {
          console.log("登录出错");
          resolve(false);
        }
      }
    });
  });
}

export default {
  userLogin
};
